/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/no-distracting-elements */
/* eslint-disable arrow-body-style */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'
import Marquee from 'react-fast-marquee'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import TestimonialItem from './testimonialItem'
import { STATIC_VARIANT, TESTIMONIAL_PATTERN } from './constants'
import styles from './testimonial.module.scss'

const TestimonialItems = ({ testimonialValues, isBusinessPage = false }) => {
  if (!testimonialValues?.testimonialItems || testimonialValues.testimonialItems.length === 0) {
    return null
  }

  return testimonialValues?.variant !== STATIC_VARIANT ? (
    <Marquee>
      {testimonialValues.testimonialItems.map((userReviewItem, index) => (
        <TestimonialItem userReviewItem={userReviewItem} index={index} isBusinessPage={isBusinessPage} />
      ))}
    </Marquee>
  ) : (
    <div className={styles.testimonialContainer}>
      {testimonialValues.testimonialItems.map((userReviewItem, index) => {
        return (
          <div className={styles.cardRootContainer} key={`${userReviewItem.customerName}${index}`}>
            <Image
              src={`${assetLoader()}${TESTIMONIAL_PATTERN}`}
              alt="Testimonial Pattern"
              height="20"
              width="100"
              loading="lazy"
            />

            <div className={styles.userReview}>{userReviewItem.userRatingReview}</div>

            <div className={styles.authorContainer}>
              <Image
                src={userReviewItem?.userProfilePicture?.data?.attributes?.url}
                alt={`Author Profile Photo ${index}`}
                width={32}
                height={32}
                loading="lazy"
              />
              <div className={styles.authorInfo}>
                <p>{userReviewItem.customerName}</p>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default TestimonialItems
